/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import type { BodyType, ErrorType } from '../../../../shared/api/custom-instance';

import { customInstance } from '../../../../shared/api/custom-instance';
import type {
  ErrorResponse,
  GetProjectUploadUrlRequest,
  ProjectUploadExtractionRequest,
  ProjectUploadExtractionResponse,
  ProjectUploadUrlResponse,
} from './model';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * PDFファイルをS3にアップロードするためのPresigned POST URLを取得します。

## アップロード方法
1. このAPIを呼び出してURL、fields、object_keyを取得
2. 取得したURLに対してmultipart/form-dataでPOSTリクエストを送信
   - fieldsの全キー・値を先に送信
   - 最後にfileフィールドでPDFファイルを送信
3. 返却されたobject_keyを解析APIに渡す

## 制限事項
- ファイルサイズ: 最大20MB（超過時はS3からエラー）
- ファイル形式: PDFのみ

新規作成画面で使用するため、project_idは不要です。
代わりにsession_idを使用して一時領域にアップロードします。

 * @summary プロジェクト用ファイルアップロードURL取得
 */
export const createProjectUploadUrl = (
  getProjectUploadUrlRequest: BodyType<GetProjectUploadUrlRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ProjectUploadUrlResponse>(
    {
      url: `/projects/uploads`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: getProjectUploadUrlRequest,
      signal,
    },
    options,
  );
};

export const getCreateProjectUploadUrlMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProjectUploadUrl>>,
    TError,
    { data: BodyType<GetProjectUploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createProjectUploadUrl>>,
  TError,
  { data: BodyType<GetProjectUploadUrlRequest> },
  TContext
> => {
  const mutationKey = ['createProjectUploadUrl'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createProjectUploadUrl>>,
    { data: BodyType<GetProjectUploadUrlRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createProjectUploadUrl(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateProjectUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof createProjectUploadUrl>>
>;
export type CreateProjectUploadUrlMutationBody = BodyType<GetProjectUploadUrlRequest>;
export type CreateProjectUploadUrlMutationError = ErrorType<ErrorResponse>;

/**
 * @summary プロジェクト用ファイルアップロードURL取得
 */
export const useCreateProjectUploadUrl = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createProjectUploadUrl>>,
      TError,
      { data: BodyType<GetProjectUploadUrlRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createProjectUploadUrl>>,
  TError,
  { data: BodyType<GetProjectUploadUrlRequest> },
  TContext
> => {
  const mutationOptions = getCreateProjectUploadUrlMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * S3にアップロードされたPDFファイルをBedrockで解析し、
プロジェクト情報を抽出して返却します。

同期処理のため、解析完了まで待機します（10〜30秒程度）。

新規作成画面で使用するため、project_idは不要です。

 * @summary プロジェクトPDF解析
 */
export const extractProjectUpload = (
  projectUploadExtractionRequest: BodyType<ProjectUploadExtractionRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ProjectUploadExtractionResponse>(
    {
      url: `/projects/uploads/extractions`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: projectUploadExtractionRequest,
      signal,
    },
    options,
  );
};

export const getExtractProjectUploadMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof extractProjectUpload>>,
    TError,
    { data: BodyType<ProjectUploadExtractionRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof extractProjectUpload>>,
  TError,
  { data: BodyType<ProjectUploadExtractionRequest> },
  TContext
> => {
  const mutationKey = ['extractProjectUpload'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof extractProjectUpload>>,
    { data: BodyType<ProjectUploadExtractionRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return extractProjectUpload(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExtractProjectUploadMutationResult = NonNullable<
  Awaited<ReturnType<typeof extractProjectUpload>>
>;
export type ExtractProjectUploadMutationBody = BodyType<ProjectUploadExtractionRequest>;
export type ExtractProjectUploadMutationError = ErrorType<ErrorResponse>;

/**
 * @summary プロジェクトPDF解析
 */
export const useExtractProjectUpload = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof extractProjectUpload>>,
      TError,
      { data: BodyType<ProjectUploadExtractionRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof extractProjectUpload>>,
  TError,
  { data: BodyType<ProjectUploadExtractionRequest> },
  TContext
> => {
  const mutationOptions = getExtractProjectUploadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
